import { z } from "zod";
export const leaseSchema = z.object({
    key: z.string().min(1),
    heldBy: z.string().min(1),
    until: z.number().int().positive().finite(),
});
//# sourceMappingURL=models.js.map